import { createContext } from 'react';
import type { InsufficientCreditsDetail } from '@/api/client';

export interface CreditTopUpContextValue {
  openTopUp: (detail?: InsufficientCreditsDetail) => void;
  closeTopUp: () => void;
  isOpen: boolean;
}

export const CreditTopUpContext = createContext<CreditTopUpContextValue | undefined>(undefined);
